/**
 * Fluent ElementConfig builder.
 * @param {string} tag
 * @returns {import('./types').ElementFluent}
 */
export function el(tag) {
  const config = {
    tag: String(tag || 'div'),
    attrs: {},
    data: {},
    children: []
  };

  const api = {
    class(...parts) {
      const flat = parts.flat(Infinity).filter((p) => p != null && p !== false && p !== '');
      const existing = config.class;
      if (existing) {
        const prev = Array.isArray(existing) ? existing : [existing];
        config.class = [...prev, ...flat];
      } else {
        config.class = flat.length === 1 ? flat[0] : flat;
      }
      return api;
    },
    className(...parts) {
      return api.class(...parts);
    },
    style(obj) {
      config.style = obj;
      return api;
    },
    attr(obj) {
      if (obj && typeof obj === 'object') {
        config.attrs = { ...config.attrs, ...obj };
      }
      return api;
    },
    attrs(obj) {
      return api.attr(obj);
    },
    data(obj) {
      if (obj && typeof obj === 'object') {
        config.data = { ...config.data, ...obj };
      }
      return api;
    },
    key(k) {
      config.key = k;
      return api;
    },
    type(t) {
      config.attrs = { ...config.attrs, type: t };
      return api;
    },
    id(id) {
      config.attrs = { ...config.attrs, id };
      return api;
    },
    name(n) {
      config.attrs = { ...config.attrs, name: n };
      return api;
    },
    title(t) {
      config.attrs = { ...config.attrs, title: t };
      return api;
    },
    value(v) {
      config.attrs = { ...config.attrs, value: v };
      return api;
    },
    placeholder(p) {
      config.attrs = { ...config.attrs, placeholder: p };
      return api;
    },
    disabled(bool = true) {
      config.attrs = { ...config.attrs, disabled: Boolean(bool) };
      return api;
    },
    readonly(bool = true) {
      config.attrs = { ...config.attrs, readonly: Boolean(bool) };
      return api;
    },
    required(bool = true) {
      config.attrs = { ...config.attrs, required: Boolean(bool) };
      return api;
    },
    text(s) {
      config.children = [s];
      return api;
    },
    child(c) {
      if (!Array.isArray(config.children)) config.children = config.children != null ? [config.children] : [];
      config.children.push(c);
      return api;
    },
    children(list) {
      config.children = Array.isArray(list) ? [...list] : [list];
      return api;
    },
    showIf(fn) {
      config.showIf = fn;
      return api;
    },
    onClick(fn) {
      config.onClick = fn;
      return api;
    },
    html(enabled = true) {
      config.html = Boolean(enabled);
      return api;
    },
    build() {
      const out = {
        tag: config.tag
      };
      if (config.class != null) out.class = Array.isArray(config.class) ? [...config.class] : config.class;
      if (config.style != null) {
        out.style = typeof config.style === 'function'
          ? config.style
          : { ...config.style };
      }
      if (config.attrs && Object.keys(config.attrs).length) {
        out.attrs = { ...config.attrs };
      }
      if (config.data && Object.keys(config.data).length) {
        out.data = { ...config.data };
      }
      if (config.children != null) {
        if (Array.isArray(config.children)) {
          out.children = config.children.length === 1 ? config.children[0] : [...config.children];
        } else {
          out.children = config.children;
        }
      }
      if (config.showIf) out.showIf = config.showIf;
      if (config.onClick) out.onClick = config.onClick;
      if (config.key != null) out.key = config.key;
      if (config.html) out.html = true;
      return out;
    }
  };

  return api;
}
